import { render, staticRenderFns } from "./kindChooseViews.vue?vue&type=template&id=143faa80&scoped=true"
import script from "./kindChooseViews.vue?vue&type=script&lang=js"
export * from "./kindChooseViews.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViews.vue?vue&type=style&index=0&id=143faa80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143faa80",
  null
  
)

export default component.exports